module.exports = __webpack_public_path__ + "img/case_5.fbf011ed.png";